import Link from 'next/link';
import styled from 'styled-components';

export const Wrapper = styled(Link)<{ $height: number }>`
	display: inline-block;
	position: relative;
	z-index: 1000;
	height: ${p => p.$height}px;
`;
